import React from 'react';
import styles from './VeloxWordmark.module.css';

/**
 * The Velox lockup: letterspaced VELOX with the O drawn as a gold ring, and
 * NETWORK beside it as a quieter qualifier.
 *
 * Drawn in CSS rather than shipped as an image. The logo files have a solid
 * black background, which would sit as an opaque block on the translucent
 * drawer, and this stays sharp at any pixel ratio and any size.
 *
 * @param size    cap height of VELOX in px; everything else derives from it
 * @param showSub whether to render NETWORK at all
 */
export default function VeloxWordmark({ size = 14, showSub = true, className }) {
  return (
    <span
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={{ '--vx-wordmark-size': `${size}px` }}
      role="img"
      aria-label={showSub ? 'Velox Network' : 'Velox'}
    >
      <span className={styles.letters} aria-hidden="true">
        V<span className={styles.gap} />E<span className={styles.gap} />L
        <span className={styles.gap} />
        <span className={styles.ring} />
        <span className={styles.gap} />X
      </span>
      {showSub ? (
        <span className={styles.sub} aria-hidden="true">
          Network
        </span>
      ) : null}
    </span>
  );
}
